import {
  Box
} from "@mui/material";
import React, { useState } from "react";
import CustomHead from "../../components/Common/CustomHead";
import ContributionInfo from "./Components/ContributionInfo";

function Contribution() {
  const styles = {
    allTabStyle: {
      fontSize: "12px",
      border: "1px solid #D4D4D4",
      borderRadius: "25px",
      marginRight: "10px",
    },
  };

  const [toggleDateFilter, setToggleDateFilter] = useState(false);
  const [downloadAllow, setDownloadAllow] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);

  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const defaultStartDate = new Date(Date.now() - oneWeek);
  const defaultEndDate = new Date(Date.now() - oneDay);

  const [finalDate, setFinalDate] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });
  const [value, setValue] = useState(1);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "98%",
        mx: "auto",
        pt: 3,
        boxSizing: "border-box",
        height: `calc(100vh - 110px)`,
        overflow: "auto",
      }}
    >
      <CustomHead
        title={"Contribution Analysis"}
        dateRange={dateRange}
        setDateRange={setDateRange}
        value={value}
        setValue={setValue}
        finalDate={finalDate}
        setFinalDate={setFinalDate}
        page={"Contribution"}
        downloadPermission={true}
        setDownloadAllow={setDownloadAllow}
      />
      <ContributionInfo
        finalDate={finalDate}
        downloadPermission={downloadAllow}
        setDownloadPermission={setDownloadAllow}
      />
    </Box>
  );
}

export default Contribution;
